// **  Initial State
const initialState = {
  userData: {},
  inited: false
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'INIT':
      return {
        ...state,
        inited: true
      }
    case 'LOGIN':
      return {
        ...state,
        userData: action.data,
        inited: true,
        [action.config.storageTokenKeyName]: action[action.config.storageTokenKeyName],
        [action.config.storageRefreshTokenKeyName]: action[action.config.storageRefreshTokenKeyName]
      }
    case 'LOGOUT':
      const obj = { ...action }
      delete obj.type
      return { ...state, userData: {}, inited: true, ...obj }
    default:
      return state
  }
}

export default authReducer
